<template>
  <nav class="fixed top-0 z-30 w-full bg-dark-gray px-5 py-2 lg:py-3">
    <!-- HAMBURGER ICON - HIGHWAY LOGO - BACK BUTTON -->
    <div
      v-show="screenSize !== 'desktop'"
      class="flex items-center justify-between"
    >
      <div
        class="flex w-16 justify-start md:w-48"
        @click="onToggleMenu"
      >
        <img
          class="inline h-8 w-8 cursor-pointer"
          :class="collapsed ? 'collapsed-menu' : 'open-menu'"
          src="@/assets/menu-icon.svg"
          alt=""
        />
      </div>

      <div class="flex justify-center">
        <router-link to="/">
          <img
            class="logo logo-h"
            src="@/assets/highway_logo.svg"
            alt="highway logo"
          />
        </router-link>
      </div>

      <!-- <slot name="backButton"> -->
      <div
        class="w-16 md:w-48"
        :class="[screenSize !== 'desktop' ? 'justify-end' : '']"
      >
        <div
          v-show="
            isMounted &&
            stepName !== 'Classifications' &&
            !(
              hasAvailableCarrierElectedClassifications == false &&
              stepName == 'Identity-1'
            )
          "
          id="backButtonHeaderMobile"
          class="flex w-16 md:w-48"
          :class="[screenSize !== 'desktop' ? 'justify-end' : '']"
        />
      </div>
      <!-- </slot> -->
    </div>

    <!-- BACK BUTTON - HIGHWAY LOGO -->
    <div
      v-show="screenSize == 'desktop'"
      class="flex items-center justify-between"
    >
      <!-- <slot name="backButton"> -->
      <div class="w-16 md:w-48">
        <div
          v-show="
            isMounted &&
            stepName !== 'Classifications' &&
            !(
              hasAvailableCarrierElectedClassifications == false &&
              stepName == 'Identity-1'
            )
          "
          id="backButtonHeaderDesktop"
          class="flex w-16 md:w-48"
          :class="[screenSize !== 'desktop' ? 'justify-end' : '']"
        />
      </div>
      <!-- </slot> -->

      <div class="flex justify-center">
        <router-link to="/">
          <img
            class="logo logo-h"
            src="@/assets/highway_logo.svg"
            alt="highway logo"
          />
        </router-link>
      </div>

      <slot name="navButtons" />
    </div>
  </nav>

  <div
    v-if="screenSize !== 'desktop'"
    class="sidebar-menu-container absolute"
    :class="[!collapsed && 'w-full']"
    @click.self="closeToggleMenu"
  >
    <sidebar-menu
      :menu="menu"
      :collapsed="collapsed"
      width-collapsed="0"
      :hide-toggle="true"
      :disable-hover="true"
      :rtl="false"
      @item-click="onItemClick"
    />
  </div>
</template>

<script>
import { SidebarMenu } from 'vue-sidebar-menu';

export default {
  name: 'Hamburger Menu',
  components: {
    SidebarMenu,
  },
  props: {
    stickyTop: {
      type: Boolean,
      required: false,
      default: false,
    },
    stepName: {
      type: String,
    },
    availableCarrierElected: {
      type: Boolean,
      default: false,
    },
    nextStep: {
      type: Function,
      default: () => {},
    },
    formPosition: {
      type: Number,
    },
    savedIndex: {
      type: [Function, Number],
      default: () => {},
    },
  },
  data() {
    return {
      collapsed: true,
      isMounted: true,
      screenSize:
        window.innerWidth >= 640
          ? window.innerWidth <= 1024
            ? 'tablet'
            : 'desktop'
          : 'mobile',
    };
  },
  computed: {
    isAValidUserId() {
      return this.$store.state.users.currentUser?.id > 0;
    },
    hasAvailableCarrierElectedClassifications() {
      if (
        this.$store.state.carriers?.availableCarrierElectedClassifications
          ?.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },

    menu() {
      const menu = [];

      if (
        this.availableCarrierElected == true &&
        this.stepName !== 'classifications'
      ) {
        menu.push({ title: 'Classifications' });
      } else if (
        this.availableCarrierElected == true &&
        this.stepName == 'Classifications' &&
        this.savedIndex !== null
      ) {
        menu.push({ title: 'Return' });
      }

      menu.push(
        {
          href: '/carrier/brokers',
          title: 'My Brokers',
        },
        {
          title: 'Log Out',
        }
      );

      return menu;
    },
  },
  mounted() {
    this.isMounted = true;
    this.$store.commit('formRoutes/setOnboardingPacketViewIsMounted', true);
    addEventListener('resize', () => {
      switch (true) {
        case window.innerWidth <= 640:
          return (this.screenSize = 'mobile');
        case window.innerWidth <= 1024:
          return (this.screenSize = 'tablet');
        default:
          return (this.screenSize = 'desktop');
      }
    });
  },
  methods: {
    onItemClick(event, item) {
      const { title } = item;

      if (title === 'Classifications') {
        this.redirectToClassifications();
        this.collapsed = !this.collapsed;
      }
      if (title === 'Return') {
        this.nextStep(this.savedIndex, true);
        this.collapsed = !this.collapsed;
      }

      if (title === 'Log Out') {
        this.logOut();
        this.collapsed = !this.collapsed;
      }
    },
    onToggleMenu() {
      this.collapsed = !this.collapsed;
    },
    closeToggleMenu() {
      this.collapsed = true;
    },
    async logOut() {
      const logoutRes = await this.$store.dispatch('users/userSignOut');
      if (logoutRes) {
        this.$router.push({ name: 'SignUp' });
      }
    },
    redirectToClassifications() {
      this.$store.commit('formRoutes/setRedirectToClassifications', true);
    },
  },
};
</script>
<style scoped>
.collapsed-menu {
  transform: scale(-1);
}

.sidebar-menu-container {
  height: calc(100vh - 48px);
}

.logo-h {
  height: 15.91px !important;
}
</style>
